<template>
    <div id="mehr">
        <a href="https://play.google.com/store/apps/details?id=de.kassensystem&pcampaignid=web_share" target="_blank">
            <button>
                <img src="@/assets/Icons/kasse.png">
            </button>
        </a>
    </div>
</template>
  
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Mehr',
    components: {
        Header,
        Footer
    },
    data() {
        return{
            routeParams:String,
        }
    },
    methods:{
    },
    created(){
        this.routeParams = this.$route.params.id;
    }
}
</script>

<style lang="scss">
#mehr{
    margin-top: 5.5rem;
    margin-bottom: 4.5rem;

    button{
        width: 41%;
        max-width: 17rem;
        margin: 0.3rem;
        background-color: white;
        border: solid black 3px;
        border-radius: 13px;

        img{
            width: 100%;
            padding: 0.1rem;
        }
    }
}
</style>